import { Controller, useFormContext } from "react-hook-form";
import React, { useEffect, useState } from "react";
import type { ImageFieldV2 as TImageField } from "src/components/Form/Form.types.ts";
import { DropZoneInputV2 } from "src/components/DropZoneInputV2/DropZoneInputV2.tsx";
import { useExonnApi } from "src/exonn-api/exonn-api.tsx";
import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { emitter } from "src/state/events.ts";
import type { InvalidMediaObject } from "src/components/DropZoneInputV2/types.ts";

export const ImageFieldV2 = ({
  name,
  field,
  disabled,
}: {
  name: string;
  field: TImageField;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const form = useFormContext();
  const exonnApi = useExonnApi();

  const formContext = useResourceFormContext();
  // todo: move invalidMediaErrors state up, to resource form state
  const [invalidMedia, setInvalidMedia] = useState<InvalidMediaObject[]>();

  useEffect(() => {
    return emitter.on("formWillRefresh", ({ resource, id, type }) => {
      if (
        formContext.resource === resource &&
        formContext.id === id &&
        formContext.action === type
      ) {
        setInvalidMedia([]);
      }
    });
  }, [formContext]);
  return (
    <Controller
      key={name}
      control={form.control}
      name={name}
      render={({ field: { onChange, value, name }, formState }) => (
        <DropZoneInputV2
          client={exonnApi.client}
          label={field.label}
          name={name}
          invalidMediaValue={invalidMedia}
          onChangeInvalidMediaValue={setInvalidMedia}
          disabled={disabled}
          value={value}
          maxItems={field.maxItems}
          multiple={field.multiple}
          validationRules={field.validationRules}
          helperText={field.helperText}
          error={formState.errors.root?.[name]?.message}
          onChange={onChange}
        />
      )}
    />
  );
};
